// Sorts an array of date ranges
// where each range is an array of shape: [startDate (Date Object), endDate (Date Object)]
// Defaults to sort by end date for each range
export const sortDateRanges = (dateRanges, byEndDate = true) =>
  [...dateRanges].sort((a, b) => b[+byEndDate] - a[+byEndDate]);
